import { KYC_DOCS_BY_HREF_ID } from './accountVerificationDocs';

// CUSTOM_LINK_URLS_BY_HREF_ID maps every `<customlink id="...">` id that opens a
// page to its URL. Docs pages come from KYC_DOCS_BY_HREF_ID; the rest are
// external pages. Ids that open a tooltip instead are handled in CustomLink.
export const CUSTOM_LINK_URLS_BY_HREF_ID: Record<string, string> = {
  ...KYC_DOCS_BY_HREF_ID,
  'contact-us': 'mailto:accountexecutive@anchorage.com',
  'faq-wolfsberg-cbddq':
    'https://wolfsberg-group.org/resources?type=cbddq-fccq',
  'faq-crd-lookup': 'https://adviserinfo.sec.gov/',
  'faq-lei-guide':
    'https://www.gleif.org/en/organizational-identity/get-an-lei-vlei/get-an-lei-find-lei-issuing-organizations',
  'privacy-center': 'https://www.anchorage.com/privacy-policy',
};
